import Mapbox from './Mapbox';
import Tile from './Tile';
import Vector from './Vector';

export default {
    Mapbox,
    Tile,
    Vector
};